import { render, staticRenderFns } from "./Hair14.vue?vue&type=template&id=0a26a8bd&"
import script from "./Hair14.vue?vue&type=script&lang=js&"
export * from "./Hair14.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports